<template>
    <div>
        <el-row :gutter="10">
            <el-col :span="20">
                <el-card shadow="hover">
                    <div slot="header" class="clearfix">
                        <span>选择岗位</span>
                    </div>
                    <el-transfer v-model="pidArr" :data="pdatas" :titles="['所有岗位', '已选择岗位']"></el-transfer>
                </el-card>
                <el-card shadow="hover" style="margin-top: 10px;">
                    <div slot="header" class="clearfix">
                        <span>选择考场</span>
                    </div>
                    <el-transfer v-model="vidArr" :data="vdatas" :titles="['所有考场', '已选择考场']"></el-transfer>
                </el-card>
            </el-col>
            <el-col :span="4">
                <div>
                    <p style="padding: 10px;">
                        <el-button type="primary" icon="el-icon-c-scale-to-original" style="width: 100%;" @click="doSubmit">提交自动排座</el-button>
                    </p>
                    <p style="padding: 10px;">
                        <el-button type="danger" icon="el-icon-delete" style="width: 100%;" @click="doDelete">清空排座信息</el-button>
                    </p>
                </div>
                <div style="margin-top: 50px;">
                    <p style="padding:10px;text-align: center; font-size: 14px;">座次表</p>
                    <p style="padding: 10px;">
                        <el-select v-model="curVid" placeholder="选择考场操作...">
                            <el-option v-for="item in venues" :key="item.id" :label="item.room" :value="item.id">
                                <span style="float: left">[{{ item.name }}]-{{ item.room }}</span>
                                <span style="float: right;  font-size: 13px">
                                    <b style="color: seagreen;">{{ item.seat }}</b>
                                    /
                                    <b style="color:chocolate">{{ item.max }}</b>
                                </span>
                            </el-option>
                        </el-select>
                    </p>
                    <p style="padding: 10px;">
                        <el-button type="success" icon="el-icon-connection" style="width: 100%;" @click="doBuildZcb">生成座次表</el-button>
                    </p>
                    <p style="padding: 10px;">
                        <el-button type="warning" icon="el-icon-printer" style="width: 100%;" @click="doPrintZcb">打印座次表</el-button>
                    </p>
                    <p style="padding: 10px;">
                        <el-button type="info" icon="el-icon-printer" style="width: 100%;" @click.stop="doOpenAllPrint()">批量打印座次表</el-button>
                    </p>
                    <p style="padding: 10px;">
                        <el-button type="primary" icon="el-icon-printer" style="width: 100%;" @click="doPreviewZcb">查看进场照片</el-button>
                    </p>
                </div>
            </el-col>
        </el-row>

        <el-row></el-row>
        <el-dialog title="批量打印座次表" :visible.sync="allprintDialog" v-if="allprintDialog" append-to-body :close-on-click-modal="false" :close-on-press-escape="false">
            <AllPrint :pid="pid"></AllPrint>
        </el-dialog>
    </div>
</template>

<script>
import AllPrint from '@/comps/PlanAllPrint'

export default {
    name: 'PlanSeats',
    components: {
        AllPrint
    },
    props: {
        pid: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            vdatas: [],
            pdatas: [],
            vidArr: [],
            pidArr: [],
            curVid: '',
            venues: [],
            allprintDialog: false
        }
    },
    mounted() {
        this.init()
    },
    methods: {
        init() {
            this.doLoad()
        },
        doOpenAllPrint() {
            this.allprintDialog = true
        },
        doLoad() {
            this.vdatas = []
            this.pdatas = []
            this.vidArr = []
            this.pidArr = []
            this.$http
                .get('/ops/recruit/seats/state', {
                    params: {
                        _: new Date().getTime(),
                        pid: this.pid
                    }
                })
                .then(result => {
                    let ps = result.data.post || []
                    let vs = result.data.venues || []
                    this.venues = vs
                    ps.forEach(post => {
                        this.pdatas.push({
                            key: post.id,
                            label: '[' + post.code + '] ' + post.name + ' <已排：' + post.seat + ' / 报名：' + post.regs + '>',
                            disabled: post.regs <= post.seat
                        })
                    })
                    vs.forEach(venues => {
                        this.vdatas.push({
                            key: venues.id,
                            label: venues.room + '[' + venues.name + '] ' + ' <已排：' + venues.seat + ' / 最大：' + venues.max + '>',
                            disabled: venues.max <= venues.seat
                        })
                    })
                })
        },
        doSubmit() {
            if (!this.pidArr || this.pidArr.length === 0) {
                this.$message.error('请选择岗位')
                return
            }
            if (!this.vidArr || this.vidArr.length === 0) {
                this.$message.error('请选择考场')
                return
            }
            this.$http
                .post('/ops/recruit/seats/submit', {
                    pid: this.pid,
                    vids: this.vidArr.join(),
                    pids: this.pidArr.join()
                })
                .then(result => {
                    if (result.code === 0) {
                        this.doLoad()
                        this.$message.success('排座成功')
                    }
                })
        },
        doDelete() {
            this.$confirm('是否清空排座信息?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http
                    .post('/ops/recruit/seats/clear', {
                        pid: this.pid
                    })
                    .then(result => {
                        if (result.code === 0) {
                            this.$message.success('已清空')
                            this.doLoad()
                        }
                    })
            })
        },
        doBuildZcb() {
            if (!this.curVid) {
                this.$message.error('请选择考场')
                return
            }
            this.$confirm('是否生成座次表信息?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http
                    .post('/ops/recruit/seats/zcb/build', {
                        vid: this.curVid
                    })
                    .then(result => {
                        if (result.code === 0) {
                            this.$message.success('已生成')
                        }
                    })
            })
        },
        doPrintZcb() {
            if (!this.curVid) {
                this.$message.error('请选择考场')
                return
            }
            this.$http
                .get('/ops/recruit/seats/zcb/print', {
                    params: {
                        _: new Date().getTime(),
                        vid: this.curVid
                    }
                })
                .then(result => {
                    if (result.code == 0) {
                        let win = window.open()
                        win.document.write(result.data.info)
                        win.document.close()
                        win.focus()
                    }
                })
        },
        doPreviewZcb() {
            if (!this.curVid) {
                this.$message.error('请选择考场')
                return
            }
            this.$http
                .get('/ops/recruit/seats/zcb/preview', {
                    params: {
                        _: new Date().getTime(),
                        vid: this.curVid
                    }
                })
                .then(result => {
                    if (result.code == 0) {
                        let win = window.open()
                        win.document.write(result.data.info)
                        win.document.close()
                        win.focus()
                    }
                })
        }
    }
}
</script>

<style>
.el-transfer-panel {
    width: 420px !important;
}
</style>
